import { ETL_FILELOAD_ID } from './columnConfig';

export const tableConfig = {
  selectable: true,
  pagination: false,
  index: ETL_FILELOAD_ID,
};
